import { Grid, Paper, Typography } from "@mui/material";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import QuickBooking from "../Booking/QuickBooking";
import { TripInformation } from "./TripInformation";

type TripHeaderProps = {
  tripInformation: TripInformation;
};

const TripHeader = ({ tripInformation }: TripHeaderProps) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "carousel" } }) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
            name
          }
        }
      }
    }
  `);

  const image = data.allFile.edges.find((edge: any) => edge.node.name === tripInformation.backgroundImage)?.node
    .childImageSharp.gatsbyImageData;

  return (
    <>
      <Typography fontSize={48} variant="h1" className="mt-3">
        {t(tripInformation.title)}
      </Typography>
      <Paper elevation={1}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={9}
            sx={{
              height: "400px",
            }}
          >
            {image && (
              <GatsbyImage image={image} alt={tripInformation.title} style={{ height: "100%", width: "100%" }} />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              backgroundColor: "#f7f5f1",
            }}
          >
            <QuickBooking />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default TripHeader;
